module.exports = __webpack_public_path__ + "images/2788156193034d07aa2c1ed6c9d2dbca.jpg";